export default __webpack_public_path__ + "static/media/icon_zoom_in.9a1a98f0.svg";